import { Component } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AppState } from "src/app/app.reducer";
import { Store } from "@ngrx/store";
import { map, first, take } from "rxjs/operators";
import { GetUserRoles, GetUserCapabilites } from "src/app/login/store/auth.actions";

@Component({
  selector: "no-access",
  templateUrl: "./no-access.component.html",
  styleUrls: ["./no-access.component.scss"]
})
export class NoAccessComponent {

}